import moment from 'moment';

export const isEmailValid = email => {

    return new Promise(function (resolve, reject) {
        //eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(String(email).toLowerCase())) {
            resolve('OK')
        }
        else {
            reject('Email:' + email + ' is not valid.')
        }


    });

}


export const isNameValid = name => {

    return new Promise(function (resolve, reject) {
        //eslint-disable-next-line
        if (/^[0-9a-zA-Z_. /\'-\[\]]+$/.test(name)) {
            resolve('OK');
        }
        else {
            reject('Name ' + name + ' is invalid.')
        }

    });

}

export const isStartDateEndDateValid = (start, end) => {

    return new Promise(function (resolve, reject) {

        if (isDateValid(start)) {

            if (end === null || end === '' || end === undefined) {
                resolve('OK')
            }

            else {

                if (isDateValid(end)) {

                    var startDate = new Date(start)
                    var endDate = new Date(end)

                    if (startDate > endDate) {
                        reject('Join Date is later then Leave Date!')
                    }
                    else {
                        resolve('OK')
                    }

                }
                else {
                    reject('Leave date is invalid')
                }

            }

        }
        else {
            reject('Join Date is invalid')
        }


    });

}


export const isDateValid = d => {

    var date = moment(d);

    // return new Promise(function(resolve, reject) {
    return date.isValid();
    // });

}

